module.exports = __webpack_public_path__ + "static/media/remove-icon.c535f9f6.svg";